module.exports = __webpack_public_path__ + "static/media/1000068.333aad83.png";